module.exports = __webpack_public_path__ + "img/gallery-icon.37e31dda.png";